export default __webpack_public_path__ + "static/datelabel-dropdown-do-1-dark-3b4f660983a16bfd1fe7385c0cd310c5.png";